import texts from '../book.texts'

class Step1Controller {
    constructor($scope, $state, User) {
        this.name = 'step1'

        this.$scope = $scope
        this.$state = $state
        this.User = User
        this.window = window

        this.currentQuestion = 0

        this.questions = [{
            id: 0,
            answers: [{
                id: 0,
                GE: {
                    answer: 'ღვინო'
                },
                EN: {
                    answer: 'Wine'
                }
            }, {
                id: 1,
                GE: {
                    answer: 'ლუდი'
                },
                EN: {
                    answer: 'Beer'
                }
            }]
        }, {
            id: 1,
            answers: [{
                id: 0,
                GE: {
                    answer: 'ღამის ცხოვრება'
                },
                EN: {
                    answer: 'Nightlife'
                }
            }, {
                id: 1,
                GE: {
                    answer: 'დღის აქტივობები'
                },
                EN: {
                    answer: 'Daylife'
                }
            }]
        }, {
            id: 2,
            answers: [{
                id: 0,
                GE: {
                    answer: 'მთა'
                },
                EN: {
                    answer: 'Mountain'
                }
            }, {
                id: 1,
                GE: {
                    answer: 'სანაპირო'
                },
                EN: {
                    answer: 'Beach'
                }
            }]
        }, {
            id: 3,
            answers: [{
                id: 0,
                GE: {
                    answer: 'გარე აქტივობები'
                },
                EN: {
                    answer: 'Outdoor'
                }
            }, {
                id: 1,
                GE: {
                    answer: 'შიდა აქტივობები'
                },
                EN: {
                    answer: 'Indoor'
                }
            }]
        }, {
            id: 4,
            answers: [{
                id: 0,
                GE: {
                    answer: 'შოფინგი'
                },
                EN: {
                    answer: 'Shopping'
                }
            }, {
                id: 1,
                GE: {
                    answer: 'ლაშქრობა'
                },
                EN: {
                    answer: 'Hiking'
                }
            }]
        }, {
            id: 5,
            answers: [{
                id: 0,
                GE: {
                    answer: 'ქალაქი'
                },
                EN: {
                    answer: 'Urban'
                }
            }, {
                id: 1,
                GE: {
                    answer: 'სოფელი'
                },
                EN: {
                    answer: 'Rural'
                }
            }]
        }, {
            id: 6,
            answers: [{
                id: 0,
                GE: {
                    answer: 'ევროპა'
                },
                EN: {
                    answer: 'Europe'
                }
            }, {
                id: 1,
                GE: {
                    answer: 'აზია'
                },
                EN: {
                    answer: 'Asia'
                }
            }]
        }]

        this.interests = []
    }

    $onInit () {
        this.window.scrollTo(0, 0)

        this.render()

        this.watchLanguage()
    }

    render () {
        this.language = localStorage.getItem('tourists_lang') || 'EN'

        const {
            TITLE,
            SUB_TITLE,
            FB_ACCESS,
            QUESTION,
            CLOSE
        } = texts[this.language]

        this.title = TITLE
        this.subTitle = SUB_TITLE
        this.fbAccess = FB_ACCESS
        this.question = QUESTION
        this.closeText = CLOSE
    }

    watchLanguage () {
        this.$scope.$watch(() => localStorage.getItem('tourists_lang'), (newValue, oldValue) => {
            if (newValue && newValue !== oldValue) {
                this.render()
            }
        })
    }

    login () {
        this.User.login()
            .then(() => {
                this.$state.go('home.book.bookStep2', {
                    type: 'facebook',
                    reload: true
                })
            })
            .catch(() => {
                this.error = 'Can\'t log in app'

                setTimeout(() => {
                    this.$state.go('home')
                }, 1500)
            })
    }

    // When user clicks on answer button
    saveAnswer (ansId) {
        this.answeredId = ansId
        this.interests.push(this.questions[this.currentQuestion].answers[ansId].EN.answer)
    }

    // on nextQuestion click
    nextQuestion (ansId) {
        this.saveAnswer(ansId)

        if (this.currentQuestion + 1 === this.questions.length) {
            // this.testEnd = true
            sessionStorage.setItem('tourists_interests', JSON.stringify(this.interests))

            this.$state.go('home.book.bookStep2', {
                reload: true
            })
        } else {
            this.answeredId = -1
            this.currentQuestion = this.currentQuestion + 1
        }
    }
}

Step1Controller.$inject = ['$scope', '$state', 'User']

export default Step1Controller



// WEBPACK FOOTER //
// ./client/app/components/home/book/step1/step1.controller.js